import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTagCategorySubindustry = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1138_12522)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 6.33691,
				y: 3.48438,
				width: 5.32725,
				height: 11.6546,
				stroke: "#1D1D1D"
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 2.67285,
				y1: 14.8281,
				x2: 15.3274,
				y2: 14.8281,
				stroke: "#1D1D1D"
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 8.10254,
				y1: 5.70312,
				x2: 10.1025,
				y2: 5.70312,
				stroke: "#1D1D1D"
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 8.10254,
				y1: 7.70312,
				x2: 10.1025,
				y2: 7.70312,
				stroke: "#1D1D1D"
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 8.10254,
				y1: 9.70312,
				x2: 10.1025,
				y2: 9.70312,
				stroke: "#1D1D1D"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1138_12522",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 12.6545,
			height: 12.6546,
			fill: "white",
			transform: "translate(2.67285 2.67188)"
		})
	}) })]
});
export default SvgTagCategorySubindustry;
